import React from 'react';
import { Users, BookOpen, Clock, TrendingUp } from 'lucide-react';
import { useLang, tx } from '../i18n/LanguageContext';
import { stats } from '../data/mock';

const icons = { students: Users, courses: BookOpen, hours: Clock, projects: TrendingUp };

const StatsSection = () => {
  const { t, isRTL, lang } = useLang();
  return (
    <section className="py-12">
      <div className="site-container">
        <div className="rounded-2xl bg-gradient-to-br from-white to-slate-50 border border-slate-200 p-6 md:p-8">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {stats.map(s => {
              const Ic = icons[s.key];
              return (
                <div key={s.key} className={`flex items-center gap-3 sm:gap-4 ${isRTL ? 'flex-row-reverse text-right' : ''}`}>
                  <div className="w-10 h-10 sm:w-14 sm:h-14 rounded-xl bg-blue-50 flex items-center justify-center shrink-0">
                    <Ic className="w-5 h-5 sm:w-7 sm:h-7 text-blue-600" />
                  </div>
                  <div>
                    <div className="text-slate-900 text-xl sm:text-2xl md:text-3xl font-extrabold">{tx(lang, s.value, s.value)}</div>
                    <div className="text-slate-500 text-[11px] sm:text-xs">{t.stats[s.key]}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default StatsSection;
